module.exports = __webpack_public_path__ + "img/Dixon_Correyo.ebfe18c1.jpeg";